import React from 'react';
import NavigationStepper, {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepperItems from '../../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepperItems';
import ManagerCalendarNotifications from './ManagerCalendarNotifications/ManagerCalendarNotifications';
import ManagerCalendarViewSettings from './ManagerCalendarViewSettings/ManagerCalendarViewSettings';
import AbsenceCalendar from '../../../../../Components/Calendar/AbsenceCalendar';
import { useManagerContext } from '../../../Services/ManagerContext';
import { ServiceScheduleContextProvider } from '../../../../WorkplaceMember/Services/ServiceScheduleContext';
import ServiceScheduleCalendar from '../../../../Calendar/Components/ServiceScheduleCalendar/ServiceScheduleCalendar';
import { ServiceScheduleType } from '../../../../../graphql/graphql';
import ManagerCalendarWorkingHours from './ManagerCalendarWorkingHours/ManagerCalendarWorkingHours';
import { CustomSettingKey } from '../../../../Base/Enums/CustomSettingKey.enum';
import WorkplaceOrderingSettingsCalendar from '../../../../../Components/Calendar/WorkplaceOrderingSettingsCalendar';

interface Props {
	activeTab?: string;
}

const ManagerCalendarWrapper: React.FC<Props> = ({ activeTab }) => {
	const { workplaceId } = useManagerContext();

	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.managerCalendarWrapper.shifts',
			key: 'shifts',
			component: (params: NavigationStepperComponentParams) => (
				<>
					<ServiceScheduleContextProvider workplaceId={workplaceId}>
						<ServiceScheduleCalendar
							scheduleTypes={[
								ServiceScheduleType.Shift,
								ServiceScheduleType.ShiftExtra,
							]}
							workplaceId={workplaceId}
							navigateToOnlineOrdering={() =>
								params.setActiveStepPath('onlineOrdering')
							}
						/>
					</ServiceScheduleContextProvider>
				</>
			),
		},
		{
			name: 'component.managerCalendarWrapper.onlineOrdering',
			key: 'onlineOrdering',
			component: (params: NavigationStepperComponentParams) => (
				<WorkplaceOrderingSettingsCalendar
					workplaceId={workplaceId}
					openShifts={() => params.setActiveStepPath('shifts')}
				/>
			),
		},
		{
			name: 'component.managerCalendarWrapper.absence',
			key: 'absence',
			component: (params: NavigationStepperComponentParams) => (
				<AbsenceCalendar />
			),
		},
		{
			name: 'component.managerCalendarWrapper.workplaceCalendarSettings',
			key: 'workplaceCalendarSettings',
			component: (params: NavigationStepperComponentParams) => (
				<ManagerCalendarViewSettings
					customSettingKey={CustomSettingKey.CALENDAR_SETTINGS}
				/>
			),
		},
		{
			name: 'component.managerCalendarWrapper.notifications',
			key: 'notifications',
			component: (params: NavigationStepperComponentParams) => (
				<ManagerCalendarNotifications />
			),
		},
		{
			name: 'component.managerCalendarWrapper.workingHours',
			key: 'workingHours',
			component: (params: NavigationStepperComponentParams) => (
				<ManagerCalendarWorkingHours />
			),
		},
	];

	return (
		<NavigationStepper
			steps={steps}
			initialStepPath={activeTab ?? 'shifts'}
			canSkip
			renderItems={({ items, activeKey, onChange }) => (
				<SubTabNavigationStepperItems
					items={items}
					activeKey={activeKey}
					onChange={onChange}
				/>
			)}
		/>
	);
};

export default ManagerCalendarWrapper;
